<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :pagination.sync="pagination"
    :rows-per-page-items="[10, 25, 50]"
    :loading="loading"
  >
    <template #items="{ item }">
      <td>{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm:ss') }}</td>
      <td>{{ item.updated_by }}</td>
    </template>
  </v-data-table>
</template>

<script>
import juzmatchApi from '@/api/juzmatch'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      items: [],
      total: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      loading: false
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('date'), value: 'timestamp', sortable: false },
        { text: this.$t('updated_by'), value: 'updated_by', sortable: false }
      ]
    }
  },
  watch: {
    pagination() {
      this.fetch()
    }
  },
  methods: {
    async fetch() {
      try {
        this.loading = true
        const response = await juzmatchApi.getMemberHistoryItems({
          member_id: this.value.member_id,
          page_id: this.value.page_id,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage
        })
        const { data, total } = response.data
        this.items = data
        this.total = Number(total)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberEditHistoryDataTable.vue